import App from './App.vue';

import { router, vuetify, initVueWithAuth } from '@qsrsoft/myq-core';
import '@qsrsoft/myq-core/styles';
import 'vuetify/dist/vuetify.css';

import routes from '@/views/routes';

async function loadApp() {
  const app = await initVueWithAuth({
    app: App,
    routes,
    vuetify,
    router,
  });
  // do all your app.use here

  router.beforeEach((to, from, next) => {
    // if / then go to /home
    if (to.path === '/') {
      next('/organization/orgSettings');
      return;
    }
    next();
  });
  app.mount('#app');
}

loadApp();
